import { FC } from 'react'
import { Asset } from '../attachmentReducer'
import {
  GreyGrey60,
  GreyGrey70,
  IconFileBend,
  IconEllipsisHorizontal,
  Button,
  SequenceMenu,
  Center
} from '@sequencehq/core-components'
import { AttachmentUI } from './AttachmentUI'

export const ExistingAttachment: FC<{
  attachment: Asset
  onClickDelete: () => void
  onClickPreview: () => void
  disableModifyAttachments: false | { reason: string }
}> = ({
  attachment,
  onClickDelete,
  onClickPreview,
  disableModifyAttachments
}) => {
  return (
    <AttachmentUI
      id={attachment.id}
      name={attachment.fileName}
      fileSizeBytes={attachment.fileSizeBytes}
      icon={<IconFileBend color={GreyGrey70} />}
      onClick={onClickPreview}
      controls={
        <SequenceMenu
          alignment="bottom-right"
          menuButton={
            <Button
              variant="ghost"
              size="24px"
              data-testid={`attachment.item.${attachment.id}.menu`}
            >
              <Center>
                <IconEllipsisHorizontal color={GreyGrey60} />
              </Center>
            </Button>
          }
          items={[
            <SequenceMenu.Item
              key="delete"
              uuid="delete"
              label="Delete attachment"
              data-testid={`attachment.item.${attachment.id}.delete`}
              isDisabled={!!disableModifyAttachments}
              onClick={e => {
                e.stopPropagation()
                onClickDelete()
              }}
              style={{ color: 'red' }}
            />
          ]}
        />
      }
    />
  )
}
